/**
 * Date utility functions for Admin Reports date filtering
 */

export const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

/**
 * Subtract days from a date
 */
export const subtractDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() - days);
    return result;
};

/**
 * Calculate date range based on preset type
 */
export const calculateDateRange = (rangeType) => {
    const today = new Date();
    let startDate, endDate, label;

    switch (rangeType) {
        case 'today':
            startDate = endDate = formatDate(today);
            label = 'Today';
            break;

        case 'yesterday':
            const yesterday = subtractDays(today, 1);
            startDate = endDate = formatDate(yesterday);
            label = 'Yesterday';
            break;

        case '7':
            startDate = formatDate(subtractDays(today, 7));
            endDate = formatDate(today);
            label = 'Last 7 Days';
            break;

        case '30':
            startDate = formatDate(subtractDays(today, 30));
            endDate = formatDate(today);
            label = 'Last 30 Days';
            break;

        case 'this_month':
            startDate = formatDate(new Date(today.getFullYear(), today.getMonth(), 1));
            endDate = formatDate(today);
            label = 'This Month';
            break;

        case 'last_month':
            const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
            startDate = formatDate(lastMonthStart);
            endDate = formatDate(lastMonthEnd);
            label = 'Last Month';
            break;

        case 'this_year':
            startDate = formatDate(new Date(today.getFullYear(), 0, 1));
            endDate = formatDate(today);
            label = 'This Year';
            break;

        case 'all_time':
            startDate = '2020-01-01'; // Business start date - adjust as needed
            endDate = formatDate(today);
            label = 'All Time';
            break;

        default:
            // Default to last 30 days
            startDate = formatDate(subtractDays(today, 30));
            endDate = formatDate(today);
            label = 'Last 30 Days';
    }

    return { start_date: startDate, end_date: endDate, label };
};

/**
 * Get label for date range display
 */
export const getDateRangeLabel = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    const startStr = start.toLocaleDateString('en-US', options);
    const endStr = end.toLocaleDateString('en-US', options);

    return `${startStr} - ${endStr}`;
};
